import { action } from 'src/store/actions';

/* ProductGroup */
export const FETCH_ADMIN_PRODUCT_GROUPS = 'FETCH_ADMIN_PRODUCT_GROUPS';
export const REQUEST_ADMIN_PRODUCT_GROUPS = 'REQUEST_ADMIN_PRODUCT_GROUPS';
export const SUCCESS_ADMIN_PRODUCT_GROUPS = 'SUCCESS_ADMIN_PRODUCT_GROUPS';
export const FAILURE_ADMIN_PRODUCT_GROUPS = 'FAILURE_ADMIN_PRODUCT_GROUPS';

export const fetchAdminProductGroups = () => action(FETCH_ADMIN_PRODUCT_GROUPS);
export const requestAdminProductGroups = () => action(REQUEST_ADMIN_PRODUCT_GROUPS);
export const requestAdminProductGroupsSuccess = (response: any) => action(SUCCESS_ADMIN_PRODUCT_GROUPS, { response });
export const requestAdminProductGroupsFailure = (error: any) => action(FAILURE_ADMIN_PRODUCT_GROUPS, { error });
